import { createCommentVNode as _createCommentVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = {
  key: 0,
  class: "grid grid-cols-3 gap-3 sm:gap-2"
}
const _hoisted_3 = {
  key: 1,
  class: "text-center text-gray-400 text-sm py-10"
}
const _hoisted_4 = { class: "grid grid-cols-3 gap-3 mt-5" }
const _hoisted_5 = { class: "absolute z-10 top-0 right-0 flex items-center px-1 py-0.5" }
const _hoisted_6 = ["onClick", "title"]
const _hoisted_7 = { class: "relative z-0 top-0 left-0 group w-full h-full" }
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = ["onClick", "title"]
const _hoisted_10 = {
  key: 1,
  class: "text-xs font-bold text-white"
}
const _hoisted_11 = ["title"]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createCommentVNode(" Search box "),
    _createElementVNode("form", {
      onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
      class: "max-w-md mx-auto"
    }, [
      _createElementVNode("div", _hoisted_1, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.search) = $event)),
          type: "search",
          id: "search",
          class: "block w-full p-4 ps-10 text-sm border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500",
          placeholder: "ค้นหาเกมเล่นล่าสุด..."
        }, null, 512 /* NEED_PATCH */), [
          [_vModelText, _ctx.search]
        ]),
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" }, [
          _createElementVNode("svg", {
            class: "w-5 h-5 text-gray-500",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2",
            viewBox: "0 0 24 24"
          }, [
            _createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              d: "M21 21l-4.35-4.35m0 0A7.5 7.5 0 1 0 3 10.5a7.5 7.5 0 0 0 13.65 6.15z"
            })
          ])
        ], -1 /* HOISTED */))
      ])
    ], 32 /* NEED_HYDRATION */),
    (_ctx.loadingGames)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(9, (n) => {
            return _createElementVNode("div", {
              key: 'game-skeleton-' + n,
              class: "h-32 sm:h-36 md:h-32 xl:h-40 bg-gray-200 animate-pulse rounded"
            })
          }), 64 /* STABLE_FRAGMENT */))
        ]))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" Empty message "),
    (_ctx.gamesList.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, " ยังไม่มีเกมล่าสุด "))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _createCommentVNode(" Game list "),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gamesList, (game) => {
              return (_openBlock(), _createElementBlock("div", {
                key: game.loginCode,
                class: "relative z-0 h-32 sm:h-36 md:h-32 xl:h-40 w-full border rounded shadow-sm transition hover:bg-primary hover:text-primary overflow-hidden"
              }, [
                _createCommentVNode(" Favorite icon "),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("span", {
                    onClick: $event => (_ctx.clickBtnFavorite(game?.loginCode || '', game?.isFavorite || false)),
                    title: !game.isFavorite ? 'เพิ่มลงรายการโปรด' : 'ลบออกจากรายการโปรด'
                  }, [
                    (_openBlock(), _createElementBlock("svg", {
                      class: _normalizeClass(["size-6 drop-shadow cursor-pointer hover:text-pink-600", { 'text-white': !game.isFavorite, 'text-pink-600': game.isFavorite }]),
                      fill: "currentColor",
                      viewBox: "0 0 24 24"
                    }, [...(_cache[3] || (_cache[3] = [
                      _createElementVNode("path", { d: "m12.75 20.66 6.184-7.098c2.677-2.884 2.559-6.506.754-8.705-.898-1.095-2.206-1.816-3.72-1.855-1.293-.034-2.652.43-3.963 1.442-1.315-1.012-2.678-1.476-3.973-1.442-1.515.04-2.825.76-3.724 1.855-1.806 2.201-1.915 5.823.772 8.706l6.183 7.097c.19.216.46.34.743.34a.985.985 0 0 0 .743-.34Z" }, null, -1 /* HOISTED */)
                    ]))], 2 /* CLASS */))
                  ], 8 /* PROPS */, _hoisted_6)
                ]),
                _createCommentVNode(" Game preview "),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("img", {
                    class: _normalizeClass(["w-full h-full object-cover", { 'group-hover:grayscale': game.active, 'grayscale': !game.active }]),
                    src: game.logo?.vertical || 'https://placehold.co/300x200?text=NO+IMAGE',
                    alt: game.gameName?.toLocaleUpperCase()
                  }, null, 10 /* CLASS, PROPS */, _hoisted_8),
                  _createCommentVNode(" Overlay "),
                  _createElementVNode("div", {
                    class: _normalizeClass(["absolute z-10 top-0 left-0 flex justify-center items-center w-full h-full bg-black/50", { 'hidden group-hover:flex': game.active, 'flex': !game.active }])
                  }, [
                    (game.active)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          onClick: $event => (_ctx.clickGame(game?.loginCode || '')),
                          title: 'เล่น ' + game.gameName?.toLocaleUpperCase(),
                          type: "button",
                          class: "w-16 text-white text-xs font-semibold bg-yellow-400 rounded-lg py-1 shadow cursor-pointer"
                        }, "เล่น", 8 /* PROPS */, _hoisted_9))
                      : (_openBlock(), _createElementBlock("span", _hoisted_10, "ปิดปรับปรุง"))
                  ], 2 /* CLASS */)
                ]),
                _createCommentVNode(" Game name "),
                _createElementVNode("h4", {
                  title: game.gameName?.toLocaleUpperCase(),
                  class: "absolute z-10 bottom-0 left-1/2 -translate-x-1/2 w-full text-white text-[11px] font-semibold truncate bg-black/60 px-1 text-center cursor-default"
                }, _toDisplayString(game.gameName?.toUpperCase()), 9 /* TEXT, PROPS */, _hoisted_11)
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
  ]))
}